/**
 * Machine-readable account error codes from the API (PBI #1230).
 * Must match ScheduledSmiles.Api.Constants.AccountErrorCodes.
 */
export const AccountErrorCodes = {
  AccountDisabled: 'account_disabled',
} as const;

export type AccountErrorCode =
  (typeof AccountErrorCodes)[keyof typeof AccountErrorCodes];
